import { render, staticRenderFns } from "./panelDetails.vue?vue&type=template&id=6ded0502&"
import script from "./panelDetails.vue?vue&type=script&lang=js&"
export * from "./panelDetails.vue?vue&type=script&lang=js&"
import style0 from "./panelDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports